/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_7_PortabilityInputs */

const en_privacy_section_7_portability = /** @type {(inputs: Privacy_Section_7_PortabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Right to data portability`)
};

const lv_privacy_section_7_portability = /** @type {(inputs: Privacy_Section_7_PortabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiesības uz datu pārnesamību`)
};

/**
* | output |
* | --- |
* | "Right to data portability" |
*
* @param {Privacy_Section_7_PortabilityInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_7_portability = /** @type {((inputs?: Privacy_Section_7_PortabilityInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_7_PortabilityInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_7_portability(inputs)
	return en_privacy_section_7_portability(inputs)
});